import React from 'react';
import { useData, useField } from '../EpcrDataContext';
import { Icons } from '../EpcrIcons';
import { TextField, OptionField, AutoField, Section, ViewLayout } from '../EpcrFields';

export function EpcrViewPatient() {
  const sections = [
    { id: "demographics", label: "Demographics" },
    { id: "contact", label: "Contact" },
    { id: "history", label: "Medical History" },
    { id: "allergies", label: "Allergies" },
    { id: "medications", label: "Medications" },
    { id: "belongings", label: "Belongings" },
  ];

  return (
    <ViewLayout sections={sections}>

      <Section id="demographics" num="01" title="Demographics" meta="ePatient.*">
        <div className="fgrid">
          <div className="fcol-4"><TextField label="Last Name" elem="ePatient.02" /></div>
          <div className="fcol-4"><TextField label="First Name" elem="ePatient.03" /></div>
          <div className="fcol-4"><TextField label="Middle Initial/Name" elem="ePatient.04" /></div>
          <div className="fcol-3"><TextField label="Age" elem="ePatient.15" /></div>
          <div className="fcol-3"><OptionField label="Age Units" elem="ePatient.16" /></div>
          <div className="fcol-3"><OptionField label="Sex" elem="ePatient.25" /></div>
          <div className="fcol-3"><OptionField label="Race" elem="ePatient.14" /></div>
          <div className="fcol-4"><TextField label="Date of Birth" elem="ePatient.17" placeholder="MM/DD/YYYY" /></div>
          <div className="fcol-4"><TextField label="Social Security Number" elem="ePatient.12" placeholder="•••••••••" /></div>
          <div className="fcol-4"><AutoField label="Preferred Language(s)" elem="ePatient.24" /></div>
        </div>
      </Section>

      <Section id="contact" num="02" title="Contact Information" meta="ePatient.05–19">
        <div className="fgrid">
          <div className="fcol-8"><TextField label="Patient's Home Address" elem="ePatient.05" placeholder="Street address" /></div>
          <div className="fcol-4"><TextField label="Patient's Home ZIP Code" elem="ePatient.09" /></div>
          <div className="fcol-4"><TextField label="Patient's Home City" elem="ePatient.06" /></div>
          <div className="fcol-2"><TextField label="Patient's Home County" elem="ePatient.07" /></div>
          <div className="fcol-3"><TextField label="Patient's Home State" elem="ePatient.08" /></div>
          <div className="fcol-3"><TextField label="Patient's Country of Residence" elem="ePatient.10" /></div>
          <div className="fcol-6"><TextField label="Patient's Phone Number" elem="ePatient.18" placeholder="(555) 000-0000" /></div>
          <div className="fcol-6"><TextField label="Patient's Email Address" elem="ePatient.19" /></div>
        </div>
      </Section>

      <Section id="history" num="03" title="Medical & Surgical History" meta="eHistory.08">
        <AutoField label="Medical / Surgical History" elem="eHistory.08" />
        <div style={{ marginTop: 18 }}>
          <OptionField label="Pregnancy" elem="eHistory.18" />
        </div>
        <div style={{ marginTop: 14 }}>
          <AutoField label="Barriers to Patient Care" elem="eHistory.01" />
        </div>
      </Section>

      <Section id="allergies" num="04" title="Allergies" meta="eHistory.06 & .07">
        <div className="fgrid">
          <div className="fcol-12">
            <AutoField label="Medication Allergies" elem="eHistory.06" />
          </div>
          <div className="fcol-12">
            <AutoField label="Environmental / Food Allergies" elem="eHistory.07" />
          </div>
        </div>
      </Section>

      <Section id="medications" num="05" title="Current Medications" meta="eHistory.CurrentMedsGroup">
        <CurrentMeds />
      </Section>

      <Section id="belongings" num="06" title="Belongings" meta="ePatient.PatientPropertyGroup">
        <div style={{ padding: 24, textAlign: "center", color: "var(--epcr-ink-4)", border: "1px dashed var(--epcr-line)", borderRadius: 6 }}>
          No belongings recorded
        </div>
        <button className="btn-secondary" style={{ marginTop: 14 }}>
          <Icons.plus size={14} /> Add item
        </button>
        <div style={{ marginTop: 18 }}>
          <OptionField label="Disposition of Belongings" elem="custom.BelongingsDisposition" path="custom/BelongingsDisposition" />
        </div>
      </Section>

    </ViewLayout>
  );
}

function CurrentMeds() {
  const data = useData();
  const meds = useField("eHistory/eHistory.CurrentMedsGroup") || [];
  const list = Array.isArray(meds) ? meds : [];
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 140px 40px", gap: 0, fontSize: 11, color: "var(--epcr-ink-4)", textTransform: "uppercase", letterSpacing: "0.06em", padding: "0 12px 8px", fontWeight: 600 }}>
        <div>Medication</div>
        <div>RxNorm</div>
        <div></div>
      </div>
      <div style={{ border: "1px solid var(--epcr-line)", borderRadius: 6, overflow: "hidden" }}>
        {list.map((m, i) => (
          <div key={i} style={{
            display: "grid",
            gridTemplateColumns: "1fr 140px 40px",
            padding: "12px 14px",
            borderTop: i ? "1px solid var(--epcr-line-2)" : "none",
            alignItems: "center",
          }}>
            <div style={{ fontWeight: 500, fontSize: 13.5 }}>{data.label("eHistory.12", m["eHistory.12"]) || "—"}</div>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, color: "var(--epcr-ink-3)" }}>{m["eHistory.12"]}</div>
            <button className="icon-btn"><Icons.trash size={14} /></button>
          </div>
        ))}
        {list.length === 0 && (
          <div style={{ padding: 24, textAlign: "center", color: "var(--epcr-ink-4)" }}>No medications recorded</div>
        )}
      </div>
      <button className="btn-secondary" style={{ marginTop: 12 }}><Icons.plus size={14} /> Add medication</button>
    </div>
  );
}
